import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';

import { resolveStartParam, startParamHref } from '@/shared/config';
import { getStartParam } from '@/shared/lib/telegram';

/**
 * Открывает экран, на который указывает `?startapp=` из ссылки бота.
 *
 * Стоит внутри гарда авторизации: до входа переходить некуда, а сразу
 * после — уже есть куда.
 *
 * **Ровно один раз за жизнь приложения.** Параметр запуска живёт в
 * `initDataUnsafe` всю сессию, поэтому повторный переход выбрасывал бы
 * игрока обратно на экран из ссылки при каждом монтировании — в том числе
 * после «Назад». Отсюда `replace`: точка входа не должна оставлять
 * позади себя главную, из которой игрок никогда не приходил.
 */
export function StartParamRedirect() {
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const target = resolveStartParam(getStartParam());
    if (!target) return;

    void navigate(startParamHref(target), { replace: true });
  }, [navigate]);

  return null;
}
